import ThirdParty from './ThirdParty';

export default ThirdParty;
